import React, { memo } from "react";
import { Accordion } from "react-bootstrap";
import LessonTypeIcon from "../../../component/LessonTypeIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import Loader from "../../../component/Loader";
import { API_GET_MODULES } from "../../../ApiEndPoints";
import AxiosClient from "../../../client/AxiosClient";
import { useEffect } from "react";
import WatchedIcon from "../../../component/WatchedIcon";

function CourseContents({ course_id, changeLesson, reloadCouter = 0 }) {
  const [loading, setLoading] = useState(true);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    AxiosClient.get(API_GET_MODULES + course_id)
      .then((response) => {
        const data = response.data.data;

        if (response.success === true) {
          setContents(data);
        }

        setContents(data);
      })
      .catch((err) => {
        console.error("getting error while fetchign course contents", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reloadCouter, course_id]);

  function handleLessonChange(course_id, chapter_id, lesson_id) {
    changeLesson({
      courseId: course_id,
      chapterId: chapter_id,
      lessonId: lesson_id,
    });
  }

  return (
    <div className="course-contents">
      <h5 className="py-3 text-white px-2 bg-dark mb-0 scroll">
        Course Contents
      </h5>
      <div className="overflow-y-auto">
        {loading && (
          <div className="text-center py-2">
            <Loader />
          </div>
        )}

        {!loading && (
          <Accordion defaultActiveKey="0" flush>
            {contents.map((item, index) => {
              return (
                <Accordion.Item eventKey={index} key={`content-${index}`}>
                  <Accordion.Header className="bg-light">
                    <h5 className="mb-0 fw-500">
                      <span className="fw-400 me-2">{index + 1}</span>{" "}
                      {item.name}
                    </h5>
                  </Accordion.Header>
                  <Accordion.Body className="px-0">
                    <ul className="type-none px-0">
                      {item.lessons.map((lesson, lessonIndex) => {
                        let isQuizz = lesson.quiz_id == null ? false : true;

                        // skipping quizzz if course expired
                        if (isQuizz && !lesson?.quiz_for_api?.[0]) {
                          return null; // skip rendering if quiz_for_api[0] doesn't exist
                        }

                        return (
                          <li
                            key={`lesson-${lessonIndex}`}
                            className="py-2 mb-2 d-flex align-items-center bg-lightaccent px-3"
                            onClick={() => {
                              handleLessonChange(
                                lesson.course_id,
                                lesson.chapter_id,
                                lesson.lesson_id
                              );
                            }}
                          >
                            <WatchedIcon completed={lesson.completed} />
                            <LessonTypeIcon
                              host={lesson.host}
                              fontSize={18}
                              color={"#0056d2"}
                            />
                            <span className="ms-2">
                              {!isQuizz
                                ? lesson.name
                                : lesson.quiz_for_api[0].title}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </div>
    </div>
  );
}
export default memo(CourseContents);
